import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getWorkingResultSummaries({ date, interval, endDate = null }) {
    return axiosIns.get('/admin/working_result_summaries', {
      params: snakecaseKeys({
        date,
        interval,
        endDate,
      }),
    })
  },
  getUserWorkingResultDailySummaries({
    date,
    interval,
    userId,
    endDate = null,
  }) {
    return axiosIns.get(`/admin/working_result_summaries/daily_list/${userId}`, {
      params: snakecaseKeys({
        date,
        interval,
        userId,
        endDate,
      }),
    })
  },
}
